// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.3.1_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.15_5c916327c7a1e0ea96b4ad86b04a02b8/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.3.1_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.15_5c916327c7a1e0ea96b4ad86b04a02b8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gPwAxNxwkZkJPGbW {
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  display: inline-flex;
}

.SEKIijKkcB1JpWMA {
  background: var(--lp-color-bg-ui-tertiary);
}

.SEKIijKkcB1JpWMA [data-icon] {
  fill: var(--lp-color-fill-ui-secondary);
}

.NtW2BA8dLdUBLcgY {
  padding: var(--lp-size-2);
}

.X6P7nHzW_2Ure_xv {
  padding: var(--lp-spacing-200);
}

.wPv8qf1o6DY4dxNN {
  padding: var(--lp-spacing-300);
}

.q0iFtmZukIgfuyIf {
  padding: var(--lp-spacing-400);
}

.Bot3bpqVpgI8YD1I {
  background: var(--lp-color-brand-blue-light);
}

.uefLOkw1LRIgNClq {
  background: var(--lp-color-brand-cyan-base);
}

.NUpiukiZukgaQ6Ha {
  background: var(--lp-color-brand-purple-base);
}

.I23xZcwWsyMhtA5A {
  background: var(--lp-color-brand-pink-base);
}

.UoHobM8Md9ASWi9x {
  background: var(--lp-color-brand-orange-base);
}

.bqUTEWtYkc8gYdDB {
  background: var(--lp-color-brand-lime-base);
}

.Bs6oVrQJo0sZqFKs {
  background: var(--lp-gradient-lime-cyan);
}

.tUpWpDgu2Hw9SFi_ {
  background: var(--lp-gradient-lime-pink);
}

.VFS1mqofwQEGJW4I {
  background: var(--lp-gradient-cyan-purple);
}

.dhxxMk70CIFldugb {
  background: var(--lp-gradient-cyan-blue);
}

.pAT2cICYpjMlG5Dm {
  background: var(--lp-gradient-purple-blue);
}

.LyhQF3WRRUYwQC4B {
  background: var(--lp-gradient-purple-pink);
}

.NacY0HjCRWIvtXL2 {
  background: var(--lp-gradient-lime-blue-pale);
}

.Bot3bpqVpgI8YD1I [data-icon], .uefLOkw1LRIgNClq [data-icon], .Bs6oVrQJo0sZqFKs [data-icon], .tUpWpDgu2Hw9SFi_ [data-icon], .VFS1mqofwQEGJW4I [data-icon], .dhxxMk70CIFldugb [data-icon], .pAT2cICYpjMlG5Dm [data-icon], .LyhQF3WRRUYwQC4B [data-icon], .UoHobM8Md9ASWi9x [data-icon], .I23xZcwWsyMhtA5A [data-icon], .NUpiukiZukgaQ6Ha [data-icon] {
  fill: var(--lp-color-white-900);
}

.NacY0HjCRWIvtXL2 [data-icon], .bqUTEWtYkc8gYdDB [data-icon] {
  fill: var(--lp-color-black-700);
}
`, "",{"version":3,"sources":["webpack://./../../launchpad-ui/packages/icons/src/styles/BadgeIcon.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC","sourcesContent":[".base {\n  border-radius: 50%;\n  justify-content: center;\n  align-items: center;\n  display: inline-flex;\n}\n\n.default {\n  background: var(--lp-color-bg-ui-tertiary);\n}\n\n.default [data-icon] {\n  fill: var(--lp-color-fill-ui-secondary);\n}\n\n.tiny {\n  padding: var(--lp-size-2);\n}\n\n.small {\n  padding: var(--lp-spacing-200);\n}\n\n.medium {\n  padding: var(--lp-spacing-300);\n}\n\n.large {\n  padding: var(--lp-spacing-400);\n}\n\n.blue {\n  background: var(--lp-color-brand-blue-light);\n}\n\n.cyan {\n  background: var(--lp-color-brand-cyan-base);\n}\n\n.purple {\n  background: var(--lp-color-brand-purple-base);\n}\n\n.pink {\n  background: var(--lp-color-brand-pink-base);\n}\n\n.orange {\n  background: var(--lp-color-brand-orange-base);\n}\n\n.lime {\n  background: var(--lp-color-brand-lime-base);\n}\n\n.gradient1 {\n  background: var(--lp-gradient-lime-cyan);\n}\n\n.gradient2 {\n  background: var(--lp-gradient-lime-pink);\n}\n\n.gradient3 {\n  background: var(--lp-gradient-cyan-purple);\n}\n\n.gradient4 {\n  background: var(--lp-gradient-cyan-blue);\n}\n\n.gradient5 {\n  background: var(--lp-gradient-purple-blue);\n}\n\n.gradient6 {\n  background: var(--lp-gradient-purple-pink);\n}\n\n.gradient7 {\n  background: var(--lp-gradient-lime-blue-pale);\n}\n\n.blue [data-icon], .cyan [data-icon], .gradient1 [data-icon], .gradient2 [data-icon], .gradient3 [data-icon], .gradient4 [data-icon], .gradient5 [data-icon], .gradient6 [data-icon], .orange [data-icon], .pink [data-icon], .purple [data-icon] {\n  fill: var(--lp-color-white-900);\n}\n\n.gradient7 [data-icon], .lime [data-icon] {\n  fill: var(--lp-color-black-700);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": `gPwAxNxwkZkJPGbW`,
	"default": `SEKIijKkcB1JpWMA`,
	"tiny": `NtW2BA8dLdUBLcgY`,
	"small": `X6P7nHzW_2Ure_xv`,
	"medium": `wPv8qf1o6DY4dxNN`,
	"large": `q0iFtmZukIgfuyIf`,
	"blue": `Bot3bpqVpgI8YD1I`,
	"cyan": `uefLOkw1LRIgNClq`,
	"purple": `NUpiukiZukgaQ6Ha`,
	"pink": `I23xZcwWsyMhtA5A`,
	"orange": `UoHobM8Md9ASWi9x`,
	"lime": `bqUTEWtYkc8gYdDB`,
	"gradient1": `Bs6oVrQJo0sZqFKs`,
	"gradient2": `tUpWpDgu2Hw9SFi_`,
	"gradient3": `VFS1mqofwQEGJW4I`,
	"gradient4": `dhxxMk70CIFldugb`,
	"gradient5": `pAT2cICYpjMlG5Dm`,
	"gradient6": `LyhQF3WRRUYwQC4B`,
	"gradient7": `NacY0HjCRWIvtXL2`
};
export default ___CSS_LOADER_EXPORT___;
